import moment from 'moment'

export default {
  methods: {
    countHoursAgo (dateFrom, dateTo) {
      const start = moment(dateFrom)
      const end = moment(dateTo)
      return Number(moment.duration(end.diff(start)).asHours()).toFixed(0)
    },

    countHoursTo (dateFrom, dateTo) {
      const start = moment(dateFrom)
      const end = moment(dateTo)
      const minutes = Number(moment.duration(end.diff(start)).asMinutes()).toFixed(0)
      let hours = 0
      if (minutes > 0) hours = Math.floor(minutes / 60)
      else hours = Math.ceil(minutes / 60)
      if (minutes > 0) return hours + 2 + ' h ' + (minutes - 60 * hours) + ' min'
      else return hours + ' h ' + Math.abs((minutes - 60 * hours)) + ' min'
    }
  }
}
